import React from 'react'

// This is
// masterquotes.estdeldate
// V2 Shipment object shipment.dates.estimatedDelivery

const DeliveryETA = ({ render, name, onChange, value, inputFieldsReadOnly }) => {
    if (!render) return null
    return (
        <div className="form-group col col-lg-2">
            <label>Delivery Date (ETA):</label>
            <input
                className="form-control form-control-sm"
                name={name}
                onChange={(event) => onChange(event)}
                type="date"
                value={value}
                disabled={inputFieldsReadOnly}
            />
        </div>
    )
}

export default DeliveryETA
